var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.breadcrumbs),function(item,index){return _c('router-link',{key:index,attrs:{"to":{name: item.link}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }